import React, { useEffect, useReducer, useContext, useState } from "react";
import reducer from "./reducer";
import axios from "axios";

import {
    ADD_ITEM,
    CHANGE_ITEMS,
    CHANGE_TYPE,
    CLEAR_BASKET,
    DELETE_ITEM,
    DISPLAY_ALERT,
    EDIT_USER_SUCCESS,
    GET_CURRENT_USER_BEGIN,
    GET_CURRENT_USER_SUCCESS,
    LOADING_BEGIN,
    LOADING_ITEMS_ERROR,
    LOADING_ITEMS_SUCCESS,
    LOADING_SUCCESS,
    LOADING_TABLE_BEGIN,
    LOADING_TABLE_ERROR,
    LOADING_TABLE_SUCCESS,
    LOADING_USERS_SUCCESS,
    LOGIN_USER_ERROR,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    PROCESS_PAYMENT_SUCCESS,
    SELECT_TABLE,
    TABLE_SAVING_BEGIN,
    TABLE_SAVING_ERROR,
    TABLE_SAVING_SUCCESS,
    TOGGLE_MODAL,
    TOGGLE_PAYMENT_SCREEN,
    TOGGLE_TABLE_MENU,
    UPDATE_DESC,
    UPDATE_PRICE,
    UPDATE_QTY,
} from "./actions";

const initialState = {
    isLoading: false,
    userLoading: true,
    showAlert: false,
    alertText: "",
    alertType: "",
    user: null,
    modal: {
        isOpen: false,
        editId: null,
    },
    basket: {
        TotalPrice: 0,
        tableNum: null,
        basketItems: [],
    },
    paymentOpen: false,
    basketItems: [],
    displayItems: [],
    currentCategory: null,
    currentEdit: {},
};

const AppContext = React.createContext();
const AppProvider = ({ children }) => {
    axios.defaults.withCredentials = true;

    const [state, dispatch] = useReducer(reducer, initialState);

    const getCurrentUser = async () => {
        dispatch({ type: GET_CURRENT_USER_BEGIN });
        try {
            const { data } = await axios.get(
                "https://till-webapp-v2.onrender.com/api/v1/auth/getCurrentUser"
            );
            const { user } = data;

            dispatch({
                type: GET_CURRENT_USER_SUCCESS,
                payload: { user },
            });
        } catch (error) {
            if (error.response.status === 401) return;
            // logoutUser();
        }
    };
    useEffect(() => {
        getCurrentUser();
    }, []);

    // axios
    const authFetch = axios.create({
        baseURL: "https://till-webapp-v2.onrender.com/api/v1/",
    });

    authFetch.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // console.log(error.response)
            if (error.response.status === 401) {
                logoutUser();
            }
            return Promise.reject(error);
        }
    );

    const loginUser = async (candidatePassword) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            const { data } = await axios.post(
                "https://till-webapp-v2.onrender.com/api/v1/auth/login",
                {
                    password: candidatePassword,
                }
            );
            const { name } = data;
            // console.log(data);
            dispatch({ type: LOADING_SUCCESS });
            dispatch({
                type: LOGIN_USER_SUCCESS,
                payload: { name },
            });
        } catch (error) {
            console.log(error);
            dispatch({
                type: LOGIN_USER_ERROR,
            });
        }

        // clearAlert();
    };

    const setItems = (items) => {
        dispatch({ type: CHANGE_ITEMS, payload: { items } });
    };
    const setType = (type) => {
        dispatch({ type: CHANGE_TYPE, payload: { type } });
    };
    const addItem = (item) => {
        dispatch({ type: ADD_ITEM, payload: { item } });
        dispatch({ type: UPDATE_PRICE });
    };

    const updateQuantity = (obj, operation) => {
        const { id, quantity } = obj;
        if (quantity === 1 && operation === "decrease") {
            dispatch({ type: DELETE_ITEM, payload: { id } });
        } else {
            dispatch({ type: UPDATE_QTY, payload: { obj, operation } });
        }
        dispatch({ type: UPDATE_PRICE });
    };

    const deleteItem = (id) => {
        dispatch({ type: DELETE_ITEM, payload: { id } });
        dispatch({ type: UPDATE_PRICE });
    };

    const clearBasket = () => {
        dispatch({ type: CLEAR_BASKET });
        dispatch({ type: UPDATE_PRICE });
    };

    const toggleModal = (id, command = null) => {
        dispatch({ type: TOGGLE_MODAL, payload: { id, command } });
    };

    const editDesc = (desc) => {
        dispatch({ type: UPDATE_DESC, payload: { desc } });
    };

    const selectTable = async (id, command) => {
        if (command === "new") {
            dispatch({ type: TOGGLE_TABLE_MENU, payload: {} });
        }
        dispatch({ type: LOADING_TABLE_BEGIN, payload: { id } });

        let url = `https://till-webapp-v2.onrender.com/api/v1/tables/${id}`;
        if (command === "select") {
            //select
            if (id) {
                try {
                    const { data } = await axios.get(url, {
                        credentials: "include",
                        withCredentials: true,
                    });
                    dispatch({ type: LOADING_TABLE_SUCCESS, payload: { data, id } });
                } catch (error) {
                    console.log(error);
                    // dispatch({
                    //     type: LOGIN_USER_ERROR,
                    // });
                }
            } else {
                dispatch({ type: LOADING_TABLE_SUCCESS, payload: { id } });
            }
            dispatch({ type: UPDATE_PRICE });
        }
    };

    const findItems = async () => {
        dispatch({ type: LOADING_BEGIN });
        let url = `https://till-webapp-v2.onrender.com/api/v1/items`;

        if (state.currentCategory) {
            url = url + "/" + state.currentCategory;
        }
        try {
            const { data } = await axios.get(url, {
                headers: {
                    "Access-Control-Allow-Origin": "https://till-webapp-frontend.onrender.com/",
                    "Access-Control-Allow-Credentials": "true",
                },
            });
            await dispatch({ type: LOADING_ITEMS_SUCCESS, payload: { data } });
            await dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({
            //     type: LOGIN_USER_ERROR,
            // });
        }

        // clearAlert();
    };

    const findItem = async (id) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/items/getSingle/${id}`;
            let { data } = await axios.get(url);
            dispatch({ type: LOADING_SUCCESS });
            dispatch({ type: EDIT_USER_SUCCESS, payload: { data } });
        } catch (error) {
            console.log(error);
            // dispatch({
            //     type: LOGIN_USER_ERROR,
            // });
        }

        // clearAlert();
    };

    const saveTable = async () => {
        dispatch({ type: TABLE_SAVING_BEGIN });
        const tableNum = state.basket.tableNum;

        // console.log("in");
        if (state.basket.basketItems.length > 0) {
            try {
                let url = `https://till-webapp-v2.onrender.com/api/v1/basketItem/create`;
                const modifiedList = state.basket.basketItems.map((item) => {
                    return {
                        instruction: item.instruction,
                        quantity: item.quantity,
                        item: item.id,
                        id: item.item,
                    };
                });

                let { data } = await axios.post(url, { list: modifiedList });

                url = `https://till-webapp-v2.onrender.com/api/v1/tables/`;

                //check the data here
                let { data: returnData } = await axios.patch(url, {
                    number: tableNum,
                    items: data,
                });
                dispatch({ type: TABLE_SAVING_SUCCESS, payload: { returnData } });
            } catch (error) {
                console.log(error);
                // dispatch({
                //     type: LOGIN_USER_ERROR,
                // });
            }
        } else {
            let url = `https://till-webapp-v2.onrender.com/api/v1/tables/`;

            let { data } = await axios.patch(url, {
                number: tableNum,
                items: [],
            });
            dispatch({ type: TABLE_SAVING_SUCCESS, payload: { data } });
        }
    };
    const logoutUser = async () => {
        // console.log("logout");
        await axios.get(`https://till-webapp-v2.onrender.com/api/v1/auth/logout`);
        dispatch({ type: LOGOUT_USER });
    };

    const searchItems = async (search) => {
        dispatch({ type: LOADING_BEGIN });
        let url = `https://till-webapp-v2.onrender.com/api/v1/items/search/${search}`;
        state.currentCategory = null;
        try {
            const { data } = await axios.get(url, {});
            dispatch({ type: LOADING_SUCCESS });
            dispatch({ type: LOADING_ITEMS_SUCCESS, payload: { data } });
        } catch (error) {
            console.log(error);
            // dispatch({
            //     type: LOGIN_USER_ERROR,
            // });
        }
    };

    const getUsers = async () => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/auth/`;
            const { data } = await axios.get(url, {});
            dispatch({ type: LOADING_SUCCESS });
            dispatch({ type: LOADING_USERS_SUCCESS, payload: { data } });
        } catch (error) {
            console.log(error);
            // dispatch({
            //     type: LOGIN_USER_ERROR,
            // });
        }
    };

    const addUser = async (params) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            // console.log(params);
            let url = `https://till-webapp-v2.onrender.com/api/v1/auth/create`;
            const { data } = await axios.post(url, params);
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const getUser = async (id) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/auth/${id}`;
            const { data } = await axios.get(url, {});
            dispatch({ type: LOADING_SUCCESS });
            dispatch({ type: EDIT_USER_SUCCESS, payload: { data } });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const updateUser = async (id, params) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/auth/${id}`;
            const { data } = await axios.patch(url, params);
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const deleteUser = async (id) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/auth/${id}`;
            const { data } = await axios.delete(url, {});
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const addNewItem = async (params) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            // console.log(params);
            let url = `https://till-webapp-v2.onrender.com/api/v1/items/create`;
            const { data } = await axios.post(url, params);
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const updateItem = async (id, params) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/items/${id}`;
            const { data } = await axios.patch(url, params);
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const deleteStockItem = async (id) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/items/${id}`;
            const { data } = await axios.delete(url, {});
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const createPayment = async (params) => {
        dispatch({ type: LOADING_BEGIN });
        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/payment`;
            console.log(params);
            const { data } = await axios.post(url, params);
            dispatch({ type: LOADING_SUCCESS });
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };

    const togglePayment = async () => {
        dispatch({ type: TOGGLE_PAYMENT_SCREEN });
    };

    const updateStatus = async (id, num) => {
        dispatch({ type: LOADING_BEGIN });

        try {
            let url = `https://till-webapp-v2.onrender.com/api/v1/tables/close`;
            await axios.patch(url, { number: num });

            url = `https://till-webapp-v2.onrender.com/api/v1/tables/create`;
            await axios.post(url, { number: num, items: [] });
            dispatch({ type: LOADING_SUCCESS });
            dispatch({ type: PROCESS_PAYMENT_SUCCESS });
            dispatch({ type: TOGGLE_TABLE_MENU, payload: {} });
            await findItems();
        } catch (error) {
            console.log(error);
            // dispatch({ type: ADD_USER_ERROR });
        }
    };
    return (
        <AppContext.Provider
            value={{
                ...state,
                setItems,
                setType,
                addItem,
                updateQuantity,
                deleteItem,
                clearBasket,
                toggleModal,
                editDesc,
                selectTable,
                loginUser,
                findItems,
                saveTable,
                logoutUser,
                searchItems,
                getUsers,
                addUser,
                getUser,
                updateUser,
                deleteUser,
                addNewItem,
                findItem,
                updateItem,
                createPayment,
                deleteStockItem,
                togglePayment,
                updateStatus,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};
// make sure use
const useAppContext = () => {
    return useContext(AppContext);
};

export { AppProvider, initialState, useAppContext };
